import { useEffect, useState } from "react";
import DEFAULT_OPERATIONS from "./signIn.gql";
import { saveUserToken } from "../../features/login/LoginSlice";
import { useDispatch, useSelector } from "react-redux";
import { useMutation } from "@apollo/client";
import { useNavigate, useLocation } from "react-router-dom";
const EMAIL_REGEX = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]{2,10})+$/;
import { saveCartId } from "../../features/Cart/CartSlice";
import { useToasts } from "react-toast-notifications";
// const PASSWORD =
//   /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
/* Reference: https://stackoverflow.com/questions/19605150/regex-for-password-must-contain-at-least-eight-characters-at-least-one-number-a#:~:text=You%20may%20use%20this%20regex%20with%20multiple
but modified with GPT
*/
const PASSWORD =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*+=\[\]{}()~`\-]).{8,}$/;
import { setCompareListId } from "../../features/CompareList/CompareListSlice";
import { logGenerator } from "../../utility/logGenerator";

export const useSignIn = (props) => {
  const { cartId } = useSelector((state) => state.cartSlice);
  const { addToast } = useToasts();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [apiError, setapiError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const { signIn, createCartMutation, mergeCartsMutation, getCustomerQuery } =
    DEFAULT_OPERATIONS;

  const [fetchCartId] = useMutation(createCartMutation);
  const [mergeCarts] = useMutation(mergeCartsMutation);

  const [SignIn, { data, error: signInError }] = useMutation(signIn, {
    fetchPolicy: "no-cache",
    onCompleted: () => {
      addToast("User has been logged in successfully.", {
        appearance: "success",
        autoDismiss: true,
        style: {
          backgroundColor: "#027B51" /* Custom background color */,
          color: "#fff" /* Custom text color */,
        },
      });
    },
  });

  const isValidEmail = () => {
    if (email.trim() === "") {
      setEmailError("This is a required field!");
      return false;
    } else if (!EMAIL_REGEX.test(email)) {
      setEmailError("Please enter valid email");
      return false;
    } else {
      setEmailError("");
      return true;
    }
  };

  const isValidPassword = () => {
    if (password.trim() === "") {
      setPasswordError("This is a required field!");
      return false;
    } else if (!PASSWORD.test(password)) {
      setPasswordError(
        "Password must contain at least 8 characters including one uppercase letter, one lowercase letter, one number, and one special character."
      );
      return false;
    } else {
      setPasswordError("");
      return true;
    }
  };

  const handlePassword = () => {
    setShowPassword((show) => !show);
  };

  const validate = () => {
    if (isValidEmail() && isValidPassword()) {
      return true;
    } else {
      isValidEmail();
      isValidPassword();
    }
    return false;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!validate()) {
      return;
    }

    try {
      const signInResponse = await SignIn({
        variables: { email, password },
      });
      const token = signInResponse.data.generateCustomerToken.token;
      dispatch(saveUserToken(token));
      dispatch(setCompareListId(""));
      // If sign-in successful, check if the user came from the forgot password page
      const fromResetPassword = location.state?.fromResetPassword;
      if (fromResetPassword) {
        navigate("/", { replace: true });
      } else {
        navigate(-1);
      }
      const CartIdAfterSignIng = await fetchCartId();

      logGenerator('info', `useSignIn handleSubmit CartIdAfterSignIng : ${CartIdAfterSignIng}`);
      logGenerator('info', `useSignIn handleSubmit mergeCarts destinationCartId : ${CartIdAfterSignIng.data.cartId}`);
      logGenerator('info', `useSignIn handleSubmit mergeCarts sourceCartId : ${cartId}`);

      await mergeCarts({
        variables: {
          destinationCartId: CartIdAfterSignIng.data.cartId,
          sourceCartId: cartId,
        },
      });
      dispatch(saveCartId(CartIdAfterSignIng.data.cartId));
    } catch (error) {
      if(error.message){
        logGenerator('error', `useSignIn handleSubmit error : ${error.message}`);
      }
      if (process.env.NODE_ENV !== "production") {
        console.error(error);
      }
    }
  };

  useEffect(() => {
    if (signInError && signInError.message) {
      setapiError(signInError.message);
    }
  }, [signInError]);

  return {
    handleSubmit,
    isValidEmail,
    isValidPassword,
    setEmail,
    setPassword,
    email,
    password,
    showPassword,
    handlePassword,
    passwordError,
    emailError,
    apiError,
  };
};
